import { UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { string_type, equals } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { createThunk } from "../Redux/Redux.js";
import { OperationStatusDTO, setOperationStatuses } from "../Redux/Reducers/TelecomReducer.js";
import { LoadState$2 } from "../Global.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";
import { tryFind, ofList } from "../fable_modules/fable-library.3.7.20/Map.js";
import { empty, tail, head, isEmpty, ofArray, choose, map } from "../fable_modules/fable-library.3.7.20/List.js";
import { SimpleJson_tryParse } from "../fable_modules/Fable.SimpleJson.3.21.0/SimpleJson.fs.js";

export function loadOperationStatuses(clientNr, networkContractNr, phoneNumber) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/provisioning/%i/%i/operation/status/%s"))(clientNr)(networkContractNr)(phoneNumber)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_3, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadOperationStatusesThunk(clientNr, networkContractNr, phoneNumberOpt) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Telecom.OperationStatuses.tag === 1) {
        }
        else {
            if (getState().Telecom.OperationStatuses.tag === 2) {
            }
            else {
                dispatch(setOperationStatuses(new LoadState$2(1)));
            }
            startImmediate(singleton.Delay(() => {
                const phoneNumber = (phoneNumberOpt == null) ? "-" : phoneNumberOpt;
                return singleton.Bind(loadOperationStatuses(clientNr, networkContractNr, phoneNumber), (_arg) => {
                    let matchValue_2, json;
                    const result = _arg;
                    dispatch(setOperationStatuses((result.tag === 0) ? (new LoadState$2(2, ofList(map((o) => [o.Operation, o.StatusJson], choose((x_1) => x_1, (matchValue_2 = SimpleJson_tryParse(result.fields[0]), (matchValue_2 != null) ? ((json = matchValue_2, (json.tag === 4) ? map((jsonObj) => {
                        const _arg_1 = jsonObj;
                        if (_arg_1.tag === 5) {
                            const dict = _arg_1.fields[0];
                            const _arg_2 = choose((x) => x, ofArray([tryFind("Operation", dict), tryFind("StatusJson", dict)]));
                            let pattern_matching_result, json_1, operation;
                            if (!isEmpty(_arg_2)) {
                                if (head(_arg_2).tag === 1) {
                                    if (!isEmpty(tail(_arg_2))) {
                                        if (isEmpty(tail(tail(_arg_2)))) {
                                            pattern_matching_result = 0;
                                            json_1 = head(tail(_arg_2));
                                            operation = head(_arg_2).fields[0];
                                        }
                                        else {
                                            pattern_matching_result = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                            switch (pattern_matching_result) {
                                case 0: {
                                    return new OperationStatusDTO(operation, json_1);
                                }
                                case 1: {
                                    return void 0;
                                }
                            }
                        }
                        else {
                            return void 0;
                        }
                    }, json.fields[0]) : empty())) : empty())))))) : (new LoadState$2(3, result.fields[0]))));
                    return singleton.Zero();
                });
            }));
        }
    }));
}

